import {MenuFormat, TitleItem} from "../MenuDocumentModel";
import {ReactElement} from "react";
import {EditorItem} from "../editorUtils";
import { getTranslations } from "features/i18n/translations";
import { useAppSelector } from "lib/redux/hooks";
import { menuEditorSelectors } from "../editorSlice";

export interface TitlePreviewItemProps {
    format: MenuFormat
    title: EditorItem<TitleItem>
    degu: boolean
}

export function TitlePreviewItem(props: TitlePreviewItemProps): ReactElement {
    const document = useAppSelector(menuEditorSelectors.document);
    const language = document?.language || "de";
    const translations = getTranslations(language);

    const columnWidth = props.format === 'a4' ? '3.5rem' :
        props.format === 'a5' ? '3rem' :
        props.degu ? '3rem' : '2.2rem';

    return (
        <div className="h-[7mm] mb-[3.5mm] pb-1 border-b border-b-text
                        font-barlow text-[14pt] text-text leading-tight
                        flex items-center">
            <div className="flex-auto">
                {props.title.menuItem.title}
            </div>

            <div className={`flex-none flex text-[#888888]
                            ${props.format === 'a4' ? 'text-[10pt] gap-1' : ''}
                            ${props.format === 'a4-half' ? `text-[8pt] ${props.degu?'gap-1':'gap-2'}` : ''}
                            ${props.format === 'a5' ? 'text-[8pt] gap-1' : ''}
            `}>
                {props.degu ?
                <>
                    <span className={`text-center whitespace-nowrap`} style={{width: columnWidth}}>Art. Nr.</span>
                    <span className={`text-center`} style={{width: columnWidth}}>
                        {translations["size.Flasche"] || "Flasche"}
                    </span>
                </>
                :
                <>
                    {props.title.menuItem.sizes.map((size, index) => (
                        <span key={index}
                              className={`overflow-hidden text-center`}
                              style={{width: columnWidth}}
                        >
                            {translations[`size.${size}`] || size}
                        </span>
                    ))}
                </>
                }
            </div>
        </div>
    );
}